var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "table",
        {
          staticClass: "default documents",
          attrs: {
            "data-folder_id": _vm.topfolder.folder_id,
            "data-shiftcheck": "",
          },
        },
        [
          _c("caption", [
            _c(
              "div",
              {
                staticClass: "caption-container",
              },
              [
                _vm.breadcrumbs && !_vm.table_title
                  ? _c(
                      "div",
                      [
                        _vm.breadcrumbs[0]
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.breadcrumbs[0].url,
                                  title: _vm.$gettext("Zum Hauptordner"),
                                },
                              },
                              [
                                _c("studip-icon", {
                                  staticClass: "text-bottom",
                                  attrs: {
                                    shape: "folder-home-full",
                                    role: "clickable",
                                    size: 30,
                                  },
                                }),
                                _vm._v(" "),
                                _vm.breadcrumbs.length === 1
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.breadcrumbs[0].name) +
                                          "\n                        "
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.breadcrumbs.slice(1), function (breadcrumb) {
                          return _c(
                            "span",
                            {
                              key: breadcrumb.folder_id,
                            },
                            [
                              _vm._v("\n                        /"),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: breadcrumb.url,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(breadcrumb.name) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.table_title
                  ? _c("div", [_vm._v(_vm._s(_vm.table_title))])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _vm.topfolder.description
              ? _c("div", {
                  staticStyle: {
                    "font-size": "small",
                  },
                  domProps: {
                    innerHTML: _vm._s(_vm.topfolder.description),
                  },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "colgroup",
            [
              _vm.show_bulk_actions
                ? _c("col", {
                    staticStyle: {
                      width: "30px",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("col", {
                staticStyle: {
                  width: "36px",
                },
              }),
              _vm._v(" "),
              _c("col"),
              _vm._v(" "),
              _c("col", {
                staticClass: "responsive-hidden",
                staticStyle: {
                  width: "100px",
                },
              }),
              _vm._v(" "),
              _vm.showdownloads
                ? _c("col", {
                    staticClass: "responsive-hidden",
                    staticStyle: {
                      width: "100px",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("col", {
                staticClass: "responsive-hidden",
                staticStyle: {
                  width: "150px",
                },
              }),
              _vm._v(" "),
              _c("col", {
                staticClass: "responsive-hidden",
                staticStyle: {
                  width: "120px",
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.additionalColumns, function (name, index) {
                return _c("col", {
                  key: index,
                  staticClass: "responsive-hidden",
                  attrs: {
                    "data-filter-ignore": "",
                  },
                })
              }),
              _vm._v(" "),
              _c("col", {
                staticStyle: {
                  width: "64px",
                },
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("thead", [
            _c(
              "tr",
              {
                staticClass: "sortable",
              },
              [
                _vm.show_bulk_actions
                  ? _c(
                      "th",
                      {
                        attrs: {
                          "data-sort": "false",
                          "aria-label": _vm.$gettext(
                            "Ordner und Dateien auswählen"
                          ),
                        },
                      },
                      [
                        _c("studip-proxy-checkbox", {
                          attrs: {
                            total: _vm.allIds,
                            title: _vm.$gettext(
                              "Alle Ordner und Dateien auswählen"
                            ),
                          },
                          model: {
                            value: _vm.selectedIds,
                            callback: function callback($$v) {
                              _vm.selectedIds = $$v
                            },
                            expression: "selectedIds",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    class: _vm.sortClasses("mime_type"),
                    attrs: {
                      "aria-sort": _vm.getAriaSortString("mime_type"),
                      "aria-label": _vm.getAriaSortLabel(
                        "mime_type",
                        _vm.$gettext("Typ")
                      ),
                    },
                    on: {
                      click: function click($event) {
                        return _vm.sort("mime_type")
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#",
                          title: _vm.$gettext("Nach Typ sortieren"),
                        },
                        on: {
                          click: function click($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$gettext("Typ")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    class: _vm.sortClasses("name"),
                    attrs: {
                      "aria-sort": _vm.getAriaSortString("name"),
                      "aria-label": _vm.getAriaSortLabel(
                        "name",
                        _vm.$gettext("Name")
                      ),
                    },
                    on: {
                      click: function click($event) {
                        return _vm.sort("name")
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#",
                          title: _vm.$gettext("Nach Name sortieren"),
                        },
                        on: {
                          click: function click($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$gettext("Name")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "responsive-hidden",
                    class: _vm.sortClasses("size"),
                    attrs: {
                      "aria-sort": _vm.getAriaSortString("size"),
                      "aria-label": _vm.getAriaSortLabel(
                        "size",
                        _vm.$gettext("Größe")
                      ),
                    },
                    on: {
                      click: function click($event) {
                        return _vm.sort("size")
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#",
                          title: _vm.$gettext("Nach Größe sortieren"),
                        },
                        on: {
                          click: function click($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$gettext("Größe")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.showdownloads
                  ? _c(
                      "th",
                      {
                        staticClass: "responsive-hidden",
                        class: _vm.sortClasses("downloads"),
                        attrs: {
                          "aria-sort": _vm.getAriaSortString("downloads"),
                          "aria-label": _vm.getAriaSortLabel(
                            "downloads",
                            _vm.$gettext("Downloads")
                          ),
                        },
                        on: {
                          click: function click($event) {
                            return _vm.sort("downloads")
                          },
                        },
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "#",
                              title: _vm.$gettext("Nach Downloads sortieren"),
                            },
                            on: {
                              click: function click($event) {
                                $event.preventDefault()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$gettext("Downloads")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "responsive-hidden",
                    class: _vm.sortClasses("author_name"),
                    attrs: {
                      "aria-sort": _vm.getAriaSortString("author_name"),
                      "aria-label": _vm.getAriaSortLabel(
                        "author_name",
                        _vm.$gettext("Autor/-in")
                      ),
                    },
                    on: {
                      click: function click($event) {
                        return _vm.sort("author_name")
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#",
                          title: _vm.$gettext("Nach Autor/-in sortieren"),
                        },
                        on: {
                          click: function click($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$gettext("Autor/-in")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "responsive-hidden",
                    class: _vm.sortClasses("chdate"),
                    attrs: {
                      "aria-sort": _vm.getAriaSortString("chdate"),
                      "aria-label": _vm.getAriaSortLabel(
                        "chdate",
                        _vm.$gettext("Datum")
                      ),
                    },
                    on: {
                      click: function click($event) {
                        return _vm.sort("chdate")
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#",
                          title: _vm.$gettext("Nach Datum sortieren"),
                        },
                        on: {
                          click: function click($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$gettext("Datum")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.additionalColumns, function (name, index) {
                  return _c(
                    "th",
                    {
                      key: index,
                      staticClass: "responsive-hidden",
                      class: _vm.sortClasses(index),
                      attrs: {
                        "aria-sort": _vm.getAriaSortString(name),
                        "aria-label": _vm.getAriaSortLabel(name, name),
                      },
                      on: {
                        click: function click($event) {
                          return _vm.sort(index)
                        },
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "#",
                            title: _vm.$gettextInterpolate(
                              _vm.$gettext("Nach %{ colName } sortieren"),
                              {
                                colName: name,
                              }
                            ),
                          },
                          on: {
                            click: function click($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(name) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "actions",
                    attrs: {
                      "data-sort": "false",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$gettext("Aktionen")))]
                ),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          !_vm.hasData
            ? _c("tbody", [
                _c(
                  "tr",
                  {
                    staticClass: "empty",
                  },
                  [
                    _c(
                      "td",
                      {
                        attrs: {
                          colspan: _vm.numberOfColumns,
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Dieser Ordner ist leer")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm.displayedFolders.length + _vm.displayedFiles.length === 0
            ? _c("tbody", [
                _c(
                  "tr",
                  {
                    staticClass: "empty",
                  },
                  [
                    _c(
                      "td",
                      {
                        attrs: {
                          colspan: _vm.numberOfColumns,
                        },
                      },
                      [
                        _c("translate", [
                          _vm._v(
                            "Keine Ordner oder Dateien entsprechen Ihrem Filter."
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.displayedFolders.length > 0
            ? _c(
                "tbody",
                {
                  staticClass: "subfolders",
                },
                _vm._l(_vm.displayedFolders, function (folder) {
                  return _c(
                    "tr",
                    {
                      key: folder.id,
                      attrs: {
                        id: "row_folder_" + folder.id,
                        "data-permissions": folder.permissions,
                      },
                    },
                    [
                      _vm.show_bulk_actions
                        ? _c(
                            "td",
                            [
                              _c("studip-proxied-checkbox", {
                                attrs: {
                                  name: "ids[]",
                                  value: folder.id,
                                  "aria-label":
                                    _vm.getAriaLabelForFolder(folder),
                                },
                                model: {
                                  value: _vm.selectedIds,
                                  callback: function callback($$v) {
                                    _vm.selectedIds = $$v
                                  },
                                  expression: "selectedIds",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "document-icon",
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: folder.url,
                                id: "folder-".concat(folder.id),
                                title: _vm.$gettextInterpolate(
                                  _vm.$gettext("Ordner %{foldername} öffnen"),
                                  {
                                    foldername: folder.name,
                                  }
                                ),
                              },
                            },
                            [
                              _c("studip-icon", {
                                staticClass: "text-bottom",
                                attrs: {
                                  shape: folder.icon,
                                  size: 26,
                                  alt: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: {
                            "filter-match": _vm.valueMatchesFilter(folder.name),
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: folder.url,
                                title: _vm.$gettextInterpolate(
                                  _vm.$gettext("Ordner %{foldername} öffnen"),
                                  {
                                    foldername: folder.name,
                                  }
                                ),
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.highlightString(folder.name)
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "responsive-hidden",
                          attrs: {
                            "data-sort-value": folder.object_count,
                          },
                        },
                        [
                          folder.object_count
                            ? _c("studip-folder-size", {
                                attrs: {
                                  object_count: folder.object_count,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showdownloads
                        ? _c("td", {
                            staticClass: "responsive-hidden",
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "responsive-hidden",
                          class: {
                            "filter-match": _vm.valueMatchesFilter(
                              folder.author_name
                            ),
                          },
                        },
                        [
                          folder.author_url
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href: folder.author_url,
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.highlightString(folder.author_name)
                                      ),
                                    },
                                  }),
                                ]
                              )
                            : _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.highlightString(folder.author_name)
                                  ),
                                },
                              }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "responsive-hidden",
                          staticStyle: {
                            "white-space": "nowrap",
                          },
                        },
                        [
                          _c("studip-date-time", {
                            attrs: {
                              timestamp: folder.chdate,
                              relative: true,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.additionalColumns, function (name, index) {
                        return [
                          folder.additionalColumns &&
                          folder.additionalColumns[index] &&
                          folder.additionalColumns[index].html
                            ? _c("td", {
                                key: index,
                                staticClass: "responsive-hidden",
                                domProps: {
                                  innerHTML: _vm._s(
                                    folder.additionalColumns[index].html
                                  ),
                                },
                              })
                            : _c("td", {
                                key: index,
                                staticClass: "responsive-hidden",
                              }),
                        ]
                      }),
                      _vm._v(" "),
                      _c("td", {
                        staticClass: "actions",
                        domProps: {
                          innerHTML: _vm._s(folder.actions),
                        },
                      }),
                    ],
                    2
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.displayedFiles.length > 0
            ? _c(
                "tbody",
                {
                  staticClass: "files",
                },
                _vm._l(_vm.displayedFiles, function (file) {
                  return _c(
                    "tr",
                    {
                      key: file.id,
                      class: file.new ? "new" : "",
                      attrs: {
                        id: "fileref_" + file.id,
                        role: "row",
                        "data-permissions": _vm.getPermissions(file),
                      },
                    },
                    [
                      _vm.show_bulk_actions
                        ? _c(
                            "td",
                            [
                              _c("studip-proxied-checkbox", {
                                attrs: {
                                  name: "ids[]",
                                  value: file.id,
                                  "aria-label": _vm.getAriaLabelForFile(file),
                                },
                                model: {
                                  value: _vm.selectedIds,
                                  callback: function callback($$v) {
                                    _vm.selectedIds = $$v
                                  },
                                  expression: "selectedIds",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "document-icon",
                        },
                        [
                          file.download_url
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href: file.download_url,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    title: _vm.$gettextInterpolate(
                                      _vm.$gettext(
                                        "Datei %{filename} herunterladen"
                                      ),
                                      {
                                        filename: file.name,
                                      }
                                    ),
                                  },
                                },
                                [
                                  _c("studip-icon", {
                                    staticClass: "text-bottom",
                                    attrs: {
                                      shape: file.icon,
                                      role: "clickable",
                                      size: "24",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c("studip-icon", {
                                attrs: {
                                  shape: file.icon,
                                  role: "clickable",
                                  size: "24",
                                },
                              }),
                          _vm._v(" "),
                          file.download_url &&
                          file.mime_type.indexOf("image/") === 0
                            ? _c("a", {
                                staticClass: "lightbox-image",
                                attrs: {
                                  href: file.download_url,
                                  "data-lightbox": "gallery",
                                  title: _vm.$gettextInterpolate(
                                    _vm.$gettext("Datei %{filename} anzeigen"),
                                    {
                                      filename: file.name,
                                    }
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: {
                            "filter-match": _vm.valueMatchesFilter(file.name),
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: file.details_url,
                                "data-dialog": "",
                                id: "file-".concat(file.id),
                                title: _vm.$gettextInterpolate(
                                  _vm.$gettext(
                                    "Details zur Datei %{filename} anzeigen"
                                  ),
                                  {
                                    filename: file.name,
                                  }
                                ),
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.highlightString(file.name)
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              file.isAccessible
                                ? _c("studip-icon", {
                                    staticStyle: {
                                      "vertical-align": "text-bottom",
                                    },
                                    attrs: {
                                      shape: "accessibility",
                                      role: "info",
                                      size: "16",
                                      title: _vm.$gettext(
                                        "Diese Datei ist barrierefrei."
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          file.restrictedTermsOfUse
                            ? _c("studip-icon", {
                                attrs: {
                                  shape: "lock-locked",
                                  role: "info",
                                  size: "16",
                                  title: _vm.$gettext(
                                    "Das Herunterladen dieser Datei ist nur eingeschränkt möglich."
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "responsive-hidden",
                          attrs: {
                            "data-sort-value": file.size,
                          },
                        },
                        [
                          file.size !== null
                            ? _c("studip-file-size", {
                                attrs: {
                                  size: parseInt(file.size, 10),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showdownloads
                        ? _c(
                            "td",
                            {
                              staticClass: "responsive-hidden",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(file.downloads) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "responsive-hidden",
                          class: {
                            "filter-match": _vm.valueMatchesFilter(
                              file.author_name
                            ),
                          },
                        },
                        [
                          file.author_url
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href: file.author_url,
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.highlightString(file.author_name)
                                      ),
                                    },
                                  }),
                                ]
                              )
                            : _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.highlightString(file.author_name)
                                  ),
                                },
                              }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "responsive-hidden",
                          staticStyle: {
                            "white-space": "nowrap",
                          },
                          attrs: {
                            "data-sort-value": "file.chdate",
                          },
                        },
                        [
                          _c("studip-date-time", {
                            attrs: {
                              timestamp: file.chdate,
                              relative: true,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.additionalColumns, function (name, index) {
                        return [
                          file.additionalColumns &&
                          file.additionalColumns[index] &&
                          file.additionalColumns[index].html
                            ? _c("td", {
                                key: index,
                                staticClass: "responsive-hidden",
                                domProps: {
                                  innerHTML: _vm._s(
                                    file.additionalColumns[index].html
                                  ),
                                },
                              })
                            : _c("td", {
                                key: index,
                                staticClass: "responsive-hidden",
                              }),
                        ]
                      }),
                      _vm._v(" "),
                      _c("td", {
                        staticClass: "actions",
                        domProps: {
                          innerHTML: _vm._s(file.actions),
                        },
                      }),
                    ],
                    2
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          (_vm.topfolder.buttons && _vm.show_bulk_actions) || _vm.tfoot_link
            ? _c("tfoot", [
                _c("tr", [
                  _c(
                    "td",
                    {
                      attrs: {
                        colspan: _vm.numberOfColumns - (_vm.tfoot_link ? 1 : 0),
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "footer-items",
                        },
                        [
                          _vm.topfolder.buttons && _vm.show_bulk_actions
                            ? _c("span", {
                                ref: "buttons",
                                staticClass: "bulk-buttons",
                                domProps: {
                                  innerHTML: _vm._s(_vm.topfolder.buttons),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.tfoot_link
                            ? _c(
                                "span",
                                {
                                  attrs: {
                                    colspan:
                                      _vm.topfolder.buttons &&
                                      _vm.show_bulk_actions
                                        ? 1
                                        : _vm.numberOfColumns,
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.tfoot_link.href,
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.tfoot_link.text))]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("pagination", function () {
                            return [
                              _vm.pagination
                                ? _c("span", {
                                    staticClass: "pagination",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.pagination),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.allow_filter
        ? _c(
            "MountingPortal",
            {
              attrs: {
                "mount-to": "#table-view-filter .sidebar-widget-content div",
                name: "sidebar-content-toggle",
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter,
                    expression: "filter",
                  },
                ],
                attrs: {
                  placeholder: _vm.$gettext("Name oder Autor/in"),
                  type: "search",
                  disabled: !_vm.hasData,
                },
                domProps: {
                  value: _vm.filter,
                },
                on: {
                  input: function input($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.filter = $event.target.value
                  },
                },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }